export const iconFontAwesomeSportsFitnessBaseball = (
	<i className="fa-solid fa-baseball"></i>
);
